export const formatDinero = (valor) =>{
    return new Intl.NumberFormat("ES-MX", {
        style: "currency",
        currency: "MXN"
      }).format(valor);   
}